import React, { memo, useCallback, useContext, useMemo } from "react";
import dynamic from "next/dynamic";
import {
  fromChildExcludeContainer,
  li,
} from "../CommonForm/CommonFormInterface";
import Collection from "../Collection/Collection";
import BreadCrumbs from "@/components/BreadCrumbs/BreadCrumbs";
import Button from "../Button/Button";
import getData from "@/commonJS/getData";
import Accordion from "../Accordion/Accordion";
import SingleAccordion from "../SingleAccordion/SingleAccordion";
import Stars from "../Stars/Stars";
import Input from "../Input/Input";
import Carousel from "../Carousel/carousel";
import SelectFilterField from "../SelectFilterField/SelectFilterField";
import DynamicTable from "../DynamicTable/DynamicTable";
const CustomModal = dynamic(() => import("../CustomModal/CustomModal"), {
  ssr: false,
});
const Drawer = dynamic(() => import("../Drawer/Drawer"), {
  ssr: false,
});
const Toaster = dynamic(() => import("../Toaster/Toaster"), {
  ssr: false,
});
const OtpInput = dynamic(() => import("../OtpInput/OtpInput"), {
  ssr: false,
});
import SerachableSelect from "../SerachableSelect/SerachableSelect";
import ProgressSlider from "../ProgressSlider/ProgressSlider";
import BarGraph from "../BarGraph/BarGraph";
import List from "../List/List";
import CustomImage from "../CustomImage/CustomImage";
import CustomLink from "../CustomLink/CustomLink";
import Label from "../Label/Label";
import StyledLabel from "../StyledLabel/StyledLabel";
import MappedImage from "../MappedImage/MappedImage";
import TextArea from "../TextArea/TextArea";
import { CommonFormContext } from "../MainComponent/MainComponent";
import { useAppState } from "@/context/AppStateContext";
import { getConstructedLink } from "@/utils/getConstructedLink";
import { generateBreadcrumbList } from "@/utils/breadcrumbs";
import CommonForm from "../CommonForm/CommonForm";
import {
  getDynamicParamsHref,
  getLinkWithLocale,
} from "@/utils/getLinkWithLocale";
import useAction from "@/commonJS/Actions/actions";
import Summary from "../Summary/Summary";
import HtmlString from "../HtmlString/HtmlString";
import useConditions from "@/commonJS/verifyConditions";
import { replacePlaceholders } from "@/utils/pathMatcher";

const QrCodeGenerator = dynamic(() => import("../QrCodeGenerator/QrCodeGenerator"), {
  ssr: false,
});
const IFrame = dynamic(() => import("../IFrame/IFrame"), {
  ssr: false,
});
const CircularProgress = dynamic(
  () => import("../CircularGraph/CircularGraph"),
  {
    ssr: false,
  }
);
const ScrollableContainerWithEvent = dynamic(
  () => import("../ScrollableContainerWithEvent/ScrollableContainerWithEvent")
);
const MapComponent = dynamic(() => import("../MapComponent/MapComponent"), {
  ssr: false,
});

const RenderField = memo(
  ({
    fieldValue,
    globalState,
    fullGlobalState,
    setGlobalState,
    collectionStateOrPayload,
    path,
  }: {
    fieldValue: fromChildExcludeContainer;
    globalState: any;
    fullGlobalState: any;
    setGlobalState: Function;
    collectionStateOrPayload: any;
    path: string[];
  }) => {
    const {
      dispatch,
      state: { layoutStore, pageStore },
    } = useAppState();
    const callAction = useAction(globalState, fullGlobalState, setGlobalState);
    const context = useContext(CommonFormContext);
    const field: any = useMemo(() => {
      const fieldValueTemp = JSON.parse(JSON.stringify(fieldValue));
      const baseClasses = [fieldValueTemp?.className, fieldValueTemp?.buttonClassName]
        .map((str) => str?.trim())
        .filter(Boolean)
        .flatMap((cls: any) => cls.split(/\s+/));
      const conditionalClassNames = fieldValueTemp?.conditionalClassNames
        ? context.getClassNames(fieldValueTemp, globalState, fullGlobalState)
        : "";

      const conditionalClasses = conditionalClassNames
        .split(/\s+/)
        .filter(Boolean);
      const finalClassName = Array.from(
        new Set([...baseClasses, ...conditionalClasses])
      ).join(" ");

      fieldValueTemp.className = finalClassName;
      return fieldValueTemp;
    }, [fieldValue, globalState, fullGlobalState]);

    const storeState =
      field?.dynamicLabel?.source === "GLOBAL"
        ? fullGlobalState
        : field?.dynamicLabel?.source === "REDUX"
        ? { page: pageStore, layout: layoutStore }
        : collectionStateOrPayload;

    const extractedLabeldata = (field:any)=>{
      let keyStructure = field?.getKeywords;
      let keyValuesObject: any = {};
      Object.entries(keyStructure).forEach(([key, valueObj]: any) => {
        const extractedValue = getData(
          valueObj, 
          storeState, 
          globalState, 
          fullGlobalState, 
          { page: pageStore, layout: layoutStore }, 
          collectionStateOrPayload)?.toString() || (field?.fallback ?? "");
          keyValuesObject[key] = extractedValue ?? field?.fallback ?? "";
      });
      let content = field?.label?.replace(/\[(\w+)\]/g, (_:any, key : any) => keyValuesObject[key] ?? "");
      
      return content.toString();
    }


    const getLabelData = useCallback(() => {
      //@ts-ignore
      if(field?.getKeywords){
        return extractedLabeldata(field);
      } else{
        //@ts-ignore
        return `${field?.prefix ? field?.prefix : ""}${
          !field.staticLabelShouldRight && field?.label ? field.label : ""
        }${
          typeof field?.dynamicLabel === "object"
            ? getData(
                field.dynamicLabel,
                storeState,
                globalState,
                fullGlobalState,
                { page: pageStore, layout: layoutStore },
                collectionStateOrPayload
              )?.toString() ||
              (field?.fallback ?? "")
            : field?.dynamicLabelType === "string"
            ? globalState ?? "-"
            : ""
        }${field.staticLabelShouldRight && field?.label ? field.label : ""}${
          field?.postfix ? field?.postfix : ""
        }`;
      }
    }, [
      globalState,
      fullGlobalState,
      collectionStateOrPayload,
      pageStore,
      layoutStore,
    ]);

    const getHtmlString = useCallback(()=>{
      //@ts-ignore
      return `${field?.prefix ? field?.prefix : ""}${typeof field?.dynamicLabel === "object" ? getData(field.dynamicLabel, storeState, globalState, fullGlobalState, { page: pageStore, layout: layoutStore }, collectionStateOrPayload)?.toString() || (field?.fallback ?? "") : field?.label ?? "-"}${field?.postfix ? field?.postfix : ""}`
    }, [globalState, fullGlobalState, collectionStateOrPayload, pageStore, layoutStore])

    const extractedHref = useMemo(
      () =>
        `${field?.hrefPrefix ?? ""}${
          field.dynamicHref
            ? getConstructedLink(
                field?.dynamicHref
                  ? getData(field.dynamicHref, globalState) ?? "/404"
                  : field?.redirect_link
                  ? field?.redirect_link
                  : field.href ?? "/404",
                field?.skeleton ?? ""
              ) ?? ""
            : getDynamicParamsHref(
                field,
                globalState,
                fullGlobalState,
                pageStore,
                layoutStore
              ) ?? ""
        }${field?.hrefPostfix ?? ""}`,
      [globalState]
    );

    const getLink = useMemo(() => {
      const locale = context.locale ?? "en";
      return getLinkWithLocale(extractedHref, locale, field);
    }, [extractedHref, context.locale]);

    const activeStyles = useMemo(
      () =>
        (field?.dynamicHref
          ? getData(
              field.dynamicHref,
              field?.dynamicHref?.source === "GLOBAL"
                ? fullGlobalState
                : field?.dynamicHref?.source === "REDUX"
                ? globalState
                : globalState
            )
          : field.href) ===
        (field?.activationData
          ? getData(
              field?.activationData,
              field?.activationData?.source === "GLOBAL"
                ? fullGlobalState
                : field?.activationData?.source === "REDUX"
                ? globalState
                : globalState
            )
          : null)
          ? field?.activeItemStyle
          : {},
      []
    );

    const customLinkLabel = useMemo(
      () =>
        field?.dynamicLabel
          ? getData(field.dynamicLabel, globalState)
          : field.label
          ? field.label
          : "",
      [globalState]
    );

    const handleClickLink = useCallback(
      (e: React.MouseEvent<HTMLAnchorElement>) => {
        if (!field?.preventClickEvent) {
          context?.handleClick({}, field?.properties?.onClick, globalState);
        }
      },
      []
    );

    const handleClick = useCallback(
      (e: React.MouseEvent<HTMLParagraphElement>) => {
        context.handleClick
          ? context.handleClick(e, field, globalState)
          : () => {};
      },
      [field, globalState, layoutStore]
    );

    const handleOnMouseEnter = useCallback(
      (e: React.MouseEvent<HTMLHRElement, MouseEvent>) => {
        // @ts-ignore
        const hasActions = field?.properties?.onMouseEnter?.actions;
        if (context.handleMouseEnter && hasActions) {
          context.handleMouseEnter(e, field, globalState);
        }
      },
      [field]
    );

    const handleOnMouseLeave = useCallback(
      (e: React.MouseEvent<HTMLHRElement, MouseEvent>) => {
        // @ts-ignore
        const hasActions = field?.properties?.onMouseLeave?.actions;
        if (context.handleMouseLeave && hasActions) {
          context.handleMouseLeave(e, field, globalState);
        }
      },
      [field]
    );

    const removeErrors = useCallback((id: string) => {
      context.callAction({
        actionType: "updateState",
        update: {
          key: "inputErrors",
          field: {
            key: id,
          },
        },
        value: "",
      });
    }, []);

    const handleOnChange = useCallback(
      (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
        fieldType: string = ""
      ) => {
        if (fieldType === "INPUT") {
          if (e) {
            removeErrors(field?.id);

            //@ts-ignore
            if (field?.inputType === "file") {
              const maxSizeInMB = 5;
              const maxSizeInBytes = maxSizeInMB * 1024 * 1024;
              const files = (e as React.ChangeEvent<HTMLInputElement>).target
                .files;

              if (files && files.length > 0) {
                for (let i = 0; i < files.length; i++) {
                  if (files[i].size > maxSizeInBytes) {
                    dispatch({
                      type: "SET_REDUX_STATE",
                      payload: {
                        action: {
                          actionType: "updateReduxState",
                          reducer: "layout",
                          update: {
                            key: "toaster",
                            field: {
                              key: "type",
                            },
                          },
                        },
                        payload: "error",
                      },
                    });
                    dispatch({
                      type: "SET_REDUX_STATE",
                      payload: {
                        action: {
                          actionType: "updateReduxState",
                          reducer: "layout",
                          update: {
                            key: "toaster",
                            field: {
                              key: "message",
                            },
                          },
                        },
                        payload: "Image size should be less than 5 mb",
                      },
                    });
                    return;
                  }
                }
              }
              context.handleOnChange(
                { target: { value: { files: files } } },
                field?.properties?.onChange?.actions,
                field?.inputType,
                globalState
              );
            } else {
              context.handleOnChange(
                e,
                field?.properties?.onChange?.actions,
                field?.inputType,
                globalState
              );
            }
          }
        }
      },
      [field, globalState]
    );

    const handleOnFocus = useCallback(
      (e: React.FocusEvent<HTMLInputElement>) => {
        context.handleOnFocus(
          e,
          //@ts-ignore
          field?.properties?.onFocus?.actions,
          globalState
        );
      },
      [field]
    );

    const handleOnBlur = useCallback(
      (e: React.FocusEvent<HTMLInputElement>) => {
        //@ts-ignore
        if (!field?.preventBlurEvent) {
          //@ts-ignore
          context.handleOnBlur(
            e,
            field?.properties?.onBlur?.actions,
            globalState
          );
        }
      },
      [field]
    );

    const getInputValue = useCallback(() => {
      if (field?.hasOwnProperty("value")) {
        return field?.value;
      } else if (field?.dynamicValue) {
        const dataSource =
          field?.dynamicValue?.source === "GLOBAL"
            ? fullGlobalState
            : field?.dynamicValue?.source === "REDUX"
            ? { page: pageStore, layout: layoutStore }
            : field?.dynamicValue?.source === "LOCALSTORAGE"
            ? {}
            : globalState;
        return getData(
          field?.dynamicValue,
          dataSource,
          globalState,
          globalState,
          fullGlobalState
        );
      }
      return undefined;
    }, [globalState, fullGlobalState, pageStore, layoutStore, field]);

    const onKeyDown = useCallback(
      (e: React.KeyboardEvent<HTMLInputElement>) => {
        switch (e.key) {
          case "Enter":
            context.handleClick && field.properties?.onKeyDown?.onEnter?.actions
              ? context.handleClick(
                  e,
                  field.properties?.onKeyDown?.onEnter,
                  globalState
                )
              : () => {};
            break;
          default:
        }
      },
      [field, globalState]
    );

    const inputErrors = useCallback(() => {
      const inputErrorsObject = {
        //@ts-ignore
        showErrors:
          !field?.hideErrorMessage &&
          fullGlobalState?.inputErrors?.[field?.id] &&
          fullGlobalState?.inputErrors?.[field?.id] !== "",
        //@ts-ignore
        inputError: fullGlobalState?.inputErrors?.[field?.id],
      };
      return inputErrorsObject;
    }, [fullGlobalState, field]);

    const getDropdownData = useMemo(() => {
      return field.dataFrom
        ? getData(field?.dataFrom, storeState, globalState, fullGlobalState)
        : field.options;
    }, [globalState, fullGlobalState, storeState, layoutStore]);

    const dropdownSelectedValue = useMemo(() => {
      if (field?.value) {
        return field?.value;
      } else if (field?.dynamicSelected) {
        const dataSource =
          field?.dynamicSelected?.source === "GLOBAL"
            ? fullGlobalState
            : field?.dynamicSelected?.source === "REDUX"
            ? { page: pageStore, layout: layoutStore }
            : globalState;
        return getData(
          field?.dynamicSelected,
          dataSource,
          globalState,
          globalState,
          fullGlobalState
        );
      }
      return undefined;
    }, [globalState, fullGlobalState]);

    const onKeyDownDropdown = useCallback((event: any) => {
      field.properties?.onKeyDown?.onEnter?.actions &&
        context?.handleClick(
          event,
          field.properties?.onKeyDown?.[event.key],
          globalState
        );
    }, []);

    const validRating = useMemo(() => {
      return field?.dynamicRate
        ? getData(field?.dynamicRate, globalState)
        : field?.rating
        ? Math.min(Math.max(field?.rating, 0), field?.maxStars ?? 5)
        : 0;
    }, [globalState]);

    const generateBreadcrumbs = useMemo(() => {
      return generateBreadcrumbList({
        field,
        pathname: globalState?.original_path,
        fullGlobalState,
        globalState,
        layoutStore,
        pageStore,
        contextLocale: context?.locale,
      });
    }, [
      field?.properties,
      field?.breadcrumbs,
      globalState?.original_path,
      context?.locale,
    ]);

    const tableBodyData = useMemo(() => {
      return field?.dataFrom
        ? getData(field?.dataFrom, globalState)
        : field?.data
        ? field?.data
        : [];
    }, [globalState]);

    const extractedStyledLabel = useMemo(() => {
      let label = "";

      if (field?.mapping?.label) {
        if (field?.dynamicLabel) {
          label =
            field?.mapping?.label?.[
              getData(
                field.dynamicLabel,
                storeState,
                globalState,
                fullGlobalState,
                { page: pageStore, layout: layoutStore },
                collectionStateOrPayload
              )
            ] ||
            getData(
              field.dynamicLabel,
              storeState,
              globalState,
              fullGlobalState,
              { page: pageStore, layout: layoutStore },
              collectionStateOrPayload
            );
        } else if (field?.dynamicLabelType === "string") {
          label = field?.mapping?.label?.[globalState];
        }
      } else if (field?.dynamicLabel) {
        label = getData(
          field.dynamicLabel,
          storeState,
          globalState,
          fullGlobalState,
          { page: pageStore, layout: layoutStore },
          collectionStateOrPayload
        );
      }
      return label;
    }, [globalState]);

    const classes = useMemo(
      () =>
        field?.dynamicLabel ? getData(field.dynamicLabel, globalState) : "",
      [globalState]
    );

    const getLocalClassName = useCallback(
      (item: any) => {
        return field?.conditionalItemClassNames
          ? context.getClassNames(
              field,
              item,
              fullGlobalState,
              "itemClassName",
              "conditionalItemClassNames"
            )
          : field?.itemClassName ?? "";
      },
      [fullGlobalState]
    );

    const getLinkList = useCallback((item: any) => {
      let href = item?.link?.url ?? "/";
      const locale = context.locale ?? "en";
      if (
        !href?.includes("http") &&
        item?.link?.target !== "_blank" &&
        locale &&
        locale !== "en"
      ) {
        href = "/" + locale + href;
      }
      return href;
    }, []);

    const extractedListItemData = useMemo(() => {
      const data =
        field?.dataFrom && getData
          ? getData(field?.dataFrom, globalState) ?? []
          : field?.listItem ?? [];
      return data?.map((d: li) =>
        typeof d === "string"
          ? d
          : {
              ...d,
              localClass: getLocalClassName(d),
              localLink: getLinkList(d),
            }
      );
    }, []);

    const onClickLinkList = useCallback((item: li) => {
      context?.handleClick({}, field?.properties?.onClick, item);
    }, []);

    const onClickStyledLabel = useCallback(
      (e: React.MouseEvent<HTMLParagraphElement>) => {
        context.handleClick?.(e, field, globalState);
      },
      []
    );

    const carouselAccordionData = useMemo(
      () =>
        field?.dataFrom
          ? getData(field?.dataFrom, globalState) ?? []
          : field?.data ?? [],
      []
    );

    const collectionData = field?.dataFrom
      ? getData(
          field?.dataFrom,
          field?.dataFrom?.source === "GLOBAL"
            ? fullGlobalState
            : field?.dataFrom?.source === "REDUX"
            ? { page: pageStore, layout: layoutStore }
            : globalState
        )
      : field?.fieldKey
      ? globalState?.[field?.fieldKey]
      : field?.data
      ? field?.data
      : [];

    const filteredCollectionData = useMemo(() => {
      return collectionData?.length > 0
        ? collectionData.slice(
            globalState[field?.fieldKey ?? ""]
              ? globalState[field?.fieldKey ?? ""]?.offset ?? 0
              : field?.offset ?? 0,
            globalState[field?.fieldKey ?? ""]
              ? globalState[field?.fieldKey ?? ""]?.limit ??
                  collectionData?.length
              : field?.limit ?? collectionData?.length
          )
        : [];
    }, [collectionData, globalState, field]);

    const handleMouesHoverOnImage = useCallback(
      (e: any, setMagnifierImagePosition: Function) => {
        const { left, top, width, height } =
          e?.currentTarget?.getBoundingClientRect();

        const x = ((e.pageX - left) / width) * 100;
        const y = ((e.pageY - top - window.scrollY) / height) * 100;
        setMagnifierImagePosition({ x, y });
      },
      []
    );

    const extractedSrc = useMemo(() => {
      const baseUrl =
        field?.imageBaseUrl ??
        field?.baseUrl ??
        process.env.NEXT_PUBLIC_IMAGE_BASE_URL ??
        "";
      switch (field?.fieldType) {
        case "image":
          return field?.dynamicSrc
            ? (field?.baseUrl ?? "") +
                (getData(field?.dynamicSrc, globalState) ??
                  field?.fallback ??
                  `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/product.webp`)
            : baseUrl + (field?.src ?? "/product.webp");
        case "button":
          return baseUrl + field?.imageUrl;
        case "link":
          return baseUrl + field?.imageUrl;
        default:
          return process.env.NEXT_PUBLIC_IMAGE_BASE_URL + "/product.webp";
      }
    }, [field, globalState]);

    const activeImageStyles = useCallback(() => {
      return (field?.dynamicSrc
        ? getData(field.dynamicSrc, globalState)
        : field.src) ===
        (field?.activationData
          ? getData(
              field?.activationData,
              field?.activationData?.source === "GLOBAL"
                ? fullGlobalState
                : field?.activationData?.source === "REDUX"
                ? globalState
                : globalState
            )
          : null)
        ? field?.activeItemStyle
        : null;
    }, [field, globalState, fullGlobalState]);

    const getImageAlt = useCallback(() => {
      return (
        (field?.dynamicAlt
          ? getData(field?.dynamicAlt, globalState)
          : field?.imageAlt
          ? field?.imageAlt
          : field?.alt) ?? "default alt"
      );
    }, [field, globalState]);

    const getImagePriority = useCallback(() => {
      return field.priority === true
        ? globalState?.index >= 0
          ? globalState?.index === 0
            ? true
            : false
          : field?.priority
        : false;
    }, [field, globalState]);

    const getImageFetchPriority = useCallback(() => {
      return field.priority === true
        ? globalState?.index >= 0
          ? globalState?.index === 0
            ? "high"
            : "auto"
          : field?.priority
          ? "high"
          : "auto"
        : "auto";
    }, [field, globalState]);

    const mappedImageData = useMemo(
      () =>
        field?.dynamicValue ? getData(field?.dynamicValue, globalState) : "",
      [globalState]
    );

    const progressSliderValue = useMemo(
      () => getData(field.currentValue, globalState) ?? field?.defaultValue,
      [globalState]
    );

    const isAccordionOpen = useMemo(
      () => globalState.accordion?.[field?.fieldKey] ?? field?.openDefault,
      [globalState, field]
    );

    const onClickAccordionSummary = useCallback((event: any, item: any) => {
      if (!field?.preventClickEvent) {
        context?.handleClick({}, field?.properties?.onClick, item);
      }
    }, []);

    const onClose = useCallback(() => {
      for (let i = 0; i < field.onCloseActions?.length; i++) {
        callAction(field.onCloseActions[i]);
      }
    }, []);

    const extractedSingleAccordionLabel = useMemo(() => {
      return `${field?.prefix ? field?.prefix : ""}${
        typeof field?.dynamicLabel === "object"
          ? getData(field.dynamicLabel, globalState)?.toString() || ""
          : ""
      }${field?.postfix ? field?.postfix : ""}`;
    }, [globalState]);

    const onClickSingleAccordionSummary = useCallback((event: any) => {
      context?.handleClick(event, field);
      if (field?.preventDefaultEvent) {
        event.preventDefault();
      }
    }, []);

    const toasterType = useMemo(
      () => layoutStore.toaster?.type,
      [layoutStore.toaster]
    );

    const extractedIFrameSrc = useMemo(
      () =>
        `${field?.prefix ? field?.prefix : ""}${
          typeof field?.dynamicSrc === "object"
            ? getData(
                field.dynamicSrc,
                storeState,
                globalState,
                fullGlobalState,
                { page: pageStore, layout: layoutStore },
                collectionStateOrPayload
              )?.toString() ||
              (field?.fallback ?? "")
            : ""
        }${field?.src ?? ""}${field?.postfix ? field?.postfix : ""}`,
      []
    );
    
    const extractedIFrameTitle = useMemo(
      () =>
        `${field?.prefix ? field?.prefix : ""}${
          typeof field?.dynamicTitle === "object"
            ? getData(
                field.dynamicTitle,
                storeState,
                globalState,
                fullGlobalState,
                { page: pageStore, layout: layoutStore },
                collectionStateOrPayload
              )?.toString() ||
              (field?.fallback ?? "")
            : ""
        }${field?.title ?? ""}`,
      []
    );
    const carouselPath = useCallback(
      (index: number) => [...(path ?? []), `carousel-sr-item-${index}`],
      []
    );
    const collectionPath = useCallback(
      (index: number) => [...(path ?? []), `collection-sr-item-${index}`],
      []
    );
    const buttonPath = useCallback(
      (id: string) => [...(path ?? []), `buttoon-sr-${id}`],
      []
    );
    const accordionSummayPath = useCallback(
      (idx: number) => [
        ...(path ?? []),
        `summary-wrap-sr-${field?.fieldKey ?? ""}-${idx}`,
      ],
      []
    );
    const accordionPath = useCallback(
      (id: string, idx: number) => [
        ...(path ?? []),
        `accordian-sr-${id}-${idx}`,
      ],
      []
    );
    const customLinkPath = useMemo(() => [...(path ?? []), `link-sr`], []);
    const SingleAccordionPath = useMemo(
      () => [...(path ?? []), `single-accr-cf-sr-item`],
      []
    );
    const accordionCollectionPath = useMemo(
      () => [...(path ?? []), `single-accr-collection-sr-item`],
      []
    );
    const singleAccordionCfPath = useMemo(
      () => [...(path ?? []), `single-accr-cf-sr-item`],
      []
    );
    const customModalPath = useMemo(
      () => [...(path ?? []), `custom-modal-sr`],
      []
    );
    const toasterPath = useMemo(
      () => [...(path ?? []), `toaster-container`],
      []
    );
    const drawerPath = useCallback(
      (id: string) => [...(path ?? []), `drawer-sr-${field?.fieldKey}`],
      []
    );

    switch (field?.fieldType) {
      case "image":
        return (
          <CustomImage
            field={field}
            handleMouesHoverOnImage={handleMouesHoverOnImage}
            extractedSrc={extractedSrc}
            activeStyles={activeImageStyles()}
            handleClick={handleClick}
            imageAlt={getImageAlt()}
            imagePriority={getImagePriority()}
            imageFetchPriority={getImageFetchPriority()}
          />
        );
      case "mapped-image":
        return <MappedImage field={field} data={mappedImageData} />;
      case "table":
        return <DynamicTable field={field} bodyData={tableBodyData} />;
      case "carousel":
        return (
          <Carousel field={field} carouselData={carouselAccordionData}>
            {Array.isArray(carouselAccordionData) &&
              carouselAccordionData?.length > 0 &&
              carouselAccordionData.map((item: any, index: number) => {
                if (field?.structure) {
                  return (
                    <CommonForm
                      key={carouselPath(index).join("-")}
                      path={carouselPath(index)}
                      formJSON={[field.structure]}
                      globalState={
                        typeof item === "string"
                          ? { item: item }
                          : { ...item, index, itemCount: index + 1 }
                      }
                      fullGlobalState={fullGlobalState ?? globalState}
                    />
                  );
                } else {
                  <React.Fragment
                    key={[
                      ...(path ?? []),
                      `carousel-sr-empty-item-${index}`,
                    ].join("-")}
                  ></React.Fragment>;
                }
              })}
          </Carousel>
        );
      case "collection":
        return (
          <Collection path={path}>
            {Array.isArray(filteredCollectionData) &&
              filteredCollectionData?.length > 0 &&
              filteredCollectionData.map((item: any, index: number) => {
                if (field?.structure) {
                  return (
                    <CommonForm
                      formJSON={[field.structure]}
                      globalState={
                        typeof item === "string"
                          ? { item: item }
                          : { ...item, index, itemCount: index + 1 }
                      }
                      fullGlobalState={fullGlobalState ?? globalState}
                      key={collectionPath(index).join("-")}
                      path={collectionPath(index)}
                    />
                  );
                }
              })}
          </Collection>
        );
      case "label":
        return (
          <Label
            field={field}
            extractedLabel={getLabelData()}
            handleClick={handleClick}
            handleOnMouseEnter={handleOnMouseEnter}
            handleOnMouseLeave={handleOnMouseLeave}
          />
        );
      case "htmlString":
        return (
          <HtmlString
            field={field}
            htmlString={getHtmlString()}
            handleClick={handleClick}
            handleOnMouseEnter={handleOnMouseEnter}
            handleOnMouseLeave={handleOnMouseLeave}
          />
        );
      case "styled-label":
        return (
          <StyledLabel
            field={field}
            extractedStyledLabel={extractedStyledLabel}
            classes={classes}
            onClickStyledLabel={onClickStyledLabel}
          />
        );
      case "hr":
        return <hr style={field?.style ? field?.style : {}} />;
      case "link":
        return (
          <CustomLink
            field={field}
            activeStyles={activeStyles}
            customLinkLabel={customLinkLabel}
            customLinkHref={getLink}
            handleClickLink={handleClickLink}
          >
            {field?.children ? (
              <CommonForm
                key={customLinkPath.join("-")}
                path={customLinkPath}
                formJSON={[field.children]}
                globalState={globalState}
                fullGlobalState={fullGlobalState ?? globalState}
              />
            ) : (
              <>
                {field?.imageUrl && (
                  <CustomImage
                    key={[...(path ?? []), `link-custom-image-sr`].join("-")}
                    field={{ ...field, id: null, className: "" }}
                    activeStyles={activeStyles}
                    extractedSrc={extractedSrc}
                    handleMouesHoverOnImage={handleMouesHoverOnImage}
                    imageAlt={getImageAlt()}
                    imageFetchPriority={getImageFetchPriority()}
                    imagePriority={getImagePriority()}
                  />
                )}
              </>
            )}
          </CustomLink>
        );
      case "progress-slider":
        return <ProgressSlider field={field} value={progressSliderValue} />;
      case "circular-graph":
        const storeState =
          field?.percentageValue?.source === "GLOBAL"
            ? fullGlobalState
            : field?.percentageValue?.source === "REDUX"
            ? { page: pageStore, layout: layoutStore }
            : globalState;

        const progressValue = field?.percentageValue
          ? getData(
              field?.percentageValue,
              storeState,
              globalState,
              fullGlobalState,
              {
                page: pageStore,
                layout: layoutStore,
              }
            ) ?? 0
          : 0;
        return <CircularProgress field={field} progressValue={progressValue} />;
      case "button":
        const verifyConditions = useConditions(
          globalState,
        );
        const buttonId = field?.dynamicId
          ? getData(field?.dynamicId, globalState)
          : field?.field_key
          ? field?.field_key
          : "";
        // This is used for unique idntifier (used for activation)
        const fieldKey = field?.dynamicFieldKey
          ? getData(field?.dynamicFieldKey, globalState)
          : field?.field_key
          ? field?.field_key
          : "";

        const getButtonLabel = useCallback(() => {
          return field?.dynamicLabel
            ? getData(field?.dynamicLabel, globalState)
            : field.label;
        }, [field, globalState]);

        const disabled = field?.disabled === true ? true : Array.isArray(field?.disabled) ? verifyConditions(field?.disabled ?? [], globalState, globalState ,fullGlobalState) : false

        const activeKey = field?.activationData
          ? getData(
              field?.activationData,
              field?.activationData?.source === "GLOBAL"
                ? fullGlobalState
                : field?.activationData?.source === "REDUX"
                ? globalState
                : globalState
            )
          : null;
        return (
          <Button
            style={field?.style ? field?.style : {}}
            disabledStyle={field?.disabledStyle ? field?.disabledStyle : {}}
            className={field?.className}
            field={field}
            buttonId={buttonId}
            activeKey={activeKey}
            fieldKey={fieldKey}
            handleClick={handleClick}
            handleOnBlur={handleOnBlur}
            buttonLabel={getButtonLabel()}
            //Image related props
            handleMouesHoverOnImage={handleMouesHoverOnImage}
            extractedSrc={extractedSrc}
            activeStyles={activeImageStyles()}
            imageAlt={getImageAlt()}
            imagePriority={getImagePriority()}
            imageFetchPriority={getImageFetchPriority()}
            disabled={disabled}
          >
            {field?.children ? (
              <CommonForm
                formJSON={[field.children]}
                globalState={globalState}
                fullGlobalState={fullGlobalState ?? globalState}
                key={buttonPath(buttonId).join("-")}
                path={buttonPath(buttonId)}
              />
            ) : null}
          </Button>
        );
      case "breadcrumbs":
        return (
          <BreadCrumbs
            breadcrumbs={generateBreadcrumbs}
            layoutStyle={field?.style}
            activeStateStyle={field?.activeStyle}
          />
        );
      case "listing":
        return (
          <List
            field={field}
            extractedListItemData={extractedListItemData}
            onClickLinkList={onClickLinkList}
          />
        );
      case "accordion":
        const extractedAccordionSrc = useMemo(
          () =>
            `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}${
              field?.imageUrl ?? "/icons/down-arrow.svg"
            }`,
          [field?.imageUrl]
        );
        return (
          <Accordion field={field}>
            {carouselAccordionData.map((item: any, idx: number) => {
              return (
                <Summary
                  key={accordionSummayPath(idx).join("-")}
                  id={`accordion-${field?.accordionKey ?? ""}-item-${idx}`}
                  isSummaryOpen={isAccordionOpen}
                  detailStyles={field?.detailStyles}
                  summaryStyles={field?.summaryStyles}
                  className={field?.className ?? ""}
                  labelType={field?.labelType}
                  labelStyle={field?.tagStyle}
                  onClose={(event: any) => {
                    onClickAccordionSummary(event, item);
                  }}
                  label={
                    field?.dynamicSummaryKey
                      ? item?.[field?.dynamicSummaryKey] ?? "-"
                      : item?.question
                  }
                  closeImageConfig={{
                    src: extractedAccordionSrc,
                    alt: field?.imageAlt,
                    imageHeight: field.imageHeight,
                    imageWidth: field.imageWidth,
                    className: field?.imageClassName ?? "",
                  }}
                >
                  {field?.valueStructure ? (
                    <CommonForm
                      key={accordionPath(field?.fieldKey ?? "", idx).join("-")}
                      path={accordionPath(field?.fieldKey ?? "", idx)}
                      formJSON={[field?.valueStructure]}
                      globalState={item}
                      fullGlobalState={fullGlobalState ?? globalState}
                    />
                  ) : (
                    <p
                      style={{ ...field?.dataStyles }}
                      dangerouslySetInnerHTML={{
                        __html: field?.dynamicValueKey
                          ? item?.[field?.dynamicValueKey] ?? "-"
                          : item?.answer,
                      }}
                    />
                  )}
                </Summary>
              );
            })}
          </Accordion>
        );
      case "single-accordion":
        return (
          <SingleAccordion
            field={field}
            isAccordionOpen={isAccordionOpen}
            extractedSingleAccordionLabel={extractedSingleAccordionLabel}
            onClickSingleAccordionSummary={onClickSingleAccordionSummary}
          >
            {field?.formStructure ? (
              <CommonForm
                key={SingleAccordionPath.join("-")}
                path={SingleAccordionPath}
                formJSON={[field?.formStructure]}
                globalState={globalState}
                fullGlobalState={fullGlobalState ?? globalState}
                setGlobalState={setGlobalState}
              />
            ) : field?.structure ? (
              <Collection
                key={accordionCollectionPath.join("-")}
                path={accordionCollectionPath}
              >
                {Array.isArray(filteredCollectionData) &&
                  filteredCollectionData?.length > 0 &&
                  filteredCollectionData.map((item: any, index: number) => {
                    if (field?.structure) {
                      return (
                        <CommonForm
                          key={singleAccordionCfPath.join("-")}
                          path={singleAccordionCfPath}
                          formJSON={[field?.formStructure]}
                          globalState={item}
                          fullGlobalState={fullGlobalState ?? globalState}
                          setGlobalState={setGlobalState}
                        />
                      );
                    }
                  })}
              </Collection>
            ) : (
              <p style={{ ...field?.dataStyles }}>
                {field?.value ? field?.value : "Value"}
              </p>
            )}
          </SingleAccordion>
        );
      case "star-rating":
        return <Stars field={field} validRating={validRating} />;
      case "input":
        return (
          <Input
            inputId={field?.id ?? ""}
            field={field}
            onChange={handleOnChange}
            onFocus={handleOnFocus}
            onBlur={handleOnBlur}
            inputValue={getInputValue()}
            onKeyDown={onKeyDown}
            showErrors={inputErrors().showErrors}
            inputError={inputErrors().inputError}
          />
        );
      case "textarea":
        return (
          <TextArea
            field={field}
            onChangeText={handleOnChange}
            showErrors={inputErrors().showErrors}
            inputError={inputErrors().inputError}
            removeErrors={removeErrors}
            inputValue={getInputValue()}
          />
        );
      case "selectFilter":
        return (
          <SelectFilterField
            field={field}
            getDropdownData={getDropdownData}
            dropdownSelectedValue={dropdownSelectedValue}
            onKeyDown={onKeyDownDropdown}
            showErrors={inputErrors().showErrors}
            inputError={inputErrors().inputError}
            removeErrors={removeErrors}
          />
        );
      case "modal":
        return (
          <CustomModal field={field} onCloseModal={onClose}>
            <CommonForm
              key={customModalPath.join("-")}
              path={customModalPath}
              formJSON={[field?.structure]}
              globalState={globalState}
              fullGlobalState={fullGlobalState}
              setGlobalState={setGlobalState}
            />
          </CustomModal>
        );
      case "toaster":
        return (
          <Toaster
            field={field}
            toasterType={toasterType}
            onCloseToaster={onClose}
          >
            <CommonForm
              key={toasterPath.join("-")}
              path={toasterPath}
              formJSON={[field?.structure]}
              globalState={globalState}
              fullGlobalState={fullGlobalState}
              setGlobalState={setGlobalState}
            />
          </Toaster>
        );
      case "otpInput":
        return (
          <OtpInput
            onComplete={() => {}}
            field={field}
            globalState={globalState}
            setGlobalState={setGlobalState}
            fullGlobalState={fullGlobalState}
          />
        );
      case "drawer":
        return (
          <Drawer
            field={field}
            fullGlobalState={fullGlobalState ?? globalState}
            onCloseDrawer={onClose}
          >
            <CommonForm
              key={drawerPath(field?.fieldKey).join("-")}
              path={drawerPath(field?.fieldKey)}
              formJSON={[field?.structure]}
              globalState={globalState}
              fullGlobalState={fullGlobalState ?? globalState}
            />
          </Drawer>
        );
      case "searchable-select":
        return (
          <SerachableSelect
            path={path}
            field={field}
            globalState={globalState}
            fullGlobalState={fullGlobalState ?? globalState}
            inputValue={getInputValue()}
            showErrors={inputErrors().showErrors}
            inputError={inputErrors().inputError}
            onChange={handleOnChange}
            onKeyDown={onKeyDown}
          />
        );
      case "bar-graph":
        const extractedLabel = useCallback(
          (column: any) =>
            column?.dynamicLabel
              ? getData(column?.dynamicLabel, globalState)
              : column?.label,
          []
        );
        const extractedValue = useCallback(
          (column: any) =>
            column?.dynamicValue
              ? getData(column?.dynamicValue, globalState)
              : column?.value,
          []
        );

        const barHeight = useCallback(
          (column: any) =>
            `${
              (column?.minHeight ?? 10) +
              globalState[field?.fieldKey] * (column?.offset ?? 10) +
              20
            }px`,
          [globalState[field?.fieldKey]]
        );
        return (
          <BarGraph
            field={field}
            barHeight={barHeight}
            extractedValue={extractedValue}
            extractedLabel={extractedLabel}
          />
        );
      case "google-map":
        return (
          <MapComponent
            field={field}
            globalState={globalState}
            fullGlobalState={fullGlobalState ?? globalState}
            collectionStateOrPayload={collectionStateOrPayload}
          />
        );
      case "iframe":
        return (
          <IFrame
            field={field}
            extractedIFrameTitle={extractedIFrameTitle}
            extractedIFrameSrc={extractedIFrameSrc}
          />
        );
      case "event-on-scroll":
        return (
          <ScrollableContainerWithEvent
            path={path}
            field={field}
            globalState={globalState}
            fullGlobalState={fullGlobalState ?? globalState}
          />
        );
      case "qr-code":
        const getQrData = useMemo(() => {
          return  field?.dynamicKey
              ? getData(field?.dynamicKey, globalState)
              : field?.key
        }, [globalState, field]);
        return <QrCodeGenerator field={field} extractedKey={getQrData} />;
      default:
        return <></>;
    }
  }
);

export default memo(RenderField);
